module.exports = __webpack_public_path__ + "static/media/7.26f6915f.png";